export default "__VITE_ASSET__C_hIN9Y___"